import { axios } from "../../../library/axios"

export const refundNavision = (orderdata : any) => {
    return axios.put(`/administration/refund_navision`, orderdata)
}